import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, NgModule, Optional } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import {
  ICON_SET_FILES,
  SSR_ICON_SETS_TOKEN,
  SsrIconSet,
} from './ssr-icon-sets.token';

@NgModule({
  imports: [MatIconModule],
})
export class IconsModule {
  /**
   * Constructor
   */
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry,
    @Inject(PLATFORM_ID) private _platformId: object,
    @Optional()
    @Inject(SSR_ICON_SETS_TOKEN)
    private _ssrIconSets: SsrIconSet[] | null,
  ) {
    if (isPlatformBrowser(this._platformId)) {
      // Browser: fetch the icon sprites over HTTP with relative URLs.
      for (const { namespace, file } of ICON_SET_FILES) {
        const url = this._domSanitizer.bypassSecurityTrustResourceUrl(
          environment.base + file,
        );
        if (namespace) {
          this._matIconRegistry.addSvgIconSetInNamespace(namespace, url);
        } else {
          this._matIconRegistry.addSvgIconSet(url);
        }
      }
      return;
    }

    // Server (SSR): relative HTTP URLs (base '/') don't resolve, so the
    // Express server reads the sprites from disk and hands them over as
    // literals via SSR_ICON_SETS_TOKEN. Without this every <mat-icon
    // svgIcon="..."> rendered on the server throws "Unable to find icon".
    for (const { namespace, svg } of this._ssrIconSets ?? []) {
      const literal = this._domSanitizer.bypassSecurityTrustHtml(svg);
      if (namespace) {
        this._matIconRegistry.addSvgIconSetLiteralInNamespace(
          namespace,
          literal,
        );
      } else {
        this._matIconRegistry.addSvgIconSetLiteral(literal);
      }
    }
  }
}
